'use client';

import { Campaign, ApiKeys } from '@/types/campaign';

const CAMPAIGN_KEY = 'adforge_campaign';
const API_KEYS_KEY = 'adforge_api_keys';
const DRAFTS_KEY = 'adforge_drafts';

export function saveCampaign(campaign: Campaign): void {
  if (typeof window !== 'undefined') {
    localStorage.setItem(CAMPAIGN_KEY, JSON.stringify(campaign));
  }
}

export function loadCampaign(): Campaign | null {
  if (typeof window === 'undefined') return null;
  const data = localStorage.getItem(CAMPAIGN_KEY);
  if (!data) return null;
  try {
    return JSON.parse(data) as Campaign;
  } catch {
    return null;
  }
}

export function clearCampaign(): void {
  if (typeof window !== 'undefined') {
    localStorage.removeItem(CAMPAIGN_KEY);
  }
}

export function createNewCampaign(): Campaign {
  return {
    id: crypto.randomUUID(),
    createdAt: new Date().toISOString(),
    currentStep: 0,
    inputs: {
      landingPageUrl: '',
      offerName: '',
      aov: 0,
      funnelType: '',
      niche: '',
      targetDemographic: '',
      rawOfferText: '',
      metaAdAccountId: '',
      metaAdAccountName: '',
      metaPageId: '',
      metaPageName: '',
      metaPixelId: '',
      metaPixelName: '',
    },
    concepts: [],
    expandedImages: [],
    selectedFinalImages: [],
    videoScripts: [],
  };
}

export function saveApiKeys(keys: ApiKeys): void {
  if (typeof window !== 'undefined') {
    localStorage.setItem(API_KEYS_KEY, JSON.stringify(keys));
  }
}

export function loadApiKeys(): ApiKeys | null {
  if (typeof window === 'undefined') return null;
  const data = localStorage.getItem(API_KEYS_KEY);
  if (!data) return null;
  try {
    return JSON.parse(data) as ApiKeys;
  } catch {
    return null;
  }
}

// --- Draft Management ---

export function saveDraft(campaign: Campaign): void {
  if (typeof window === 'undefined') return;
  const drafts = loadDraftList();
  const idx = drafts.findIndex(d => d.id === campaign.id);
  const updated = { ...campaign, updatedAt: new Date().toISOString() };
  if (idx >= 0) {
    drafts[idx] = updated;
  } else {
    drafts.push(updated);
  }
  localStorage.setItem(DRAFTS_KEY, JSON.stringify(drafts));
}

export function loadDraftList(): Campaign[] {
  if (typeof window === 'undefined') return [];
  const data = localStorage.getItem(DRAFTS_KEY);
  if (!data) return [];
  try {
    return JSON.parse(data) as Campaign[];
  } catch {
    return [];
  }
}

export function loadDraft(id: string): Campaign | null {
  const drafts = loadDraftList();
  return drafts.find(d => d.id === id) || null;
}

export function deleteDraft(id: string): void {
  if (typeof window === 'undefined') return;
  const drafts = loadDraftList().filter(d => d.id !== id);
  localStorage.setItem(DRAFTS_KEY, JSON.stringify(drafts));
}
